import {
    ApiUtils,
    _axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
    headerlist: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/product/productBoard/headerlist", params, successCallback, failCallback, exceptionCallback);
    },
    productList: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/product/productBoard/productList2", params, successCallback, failCallback, exceptionCallback);
    },
    chartlist: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/product/productBoard/chartlist", params, successCallback, failCallback, exceptionCallback);
    },
    productGoalData: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/product/productBoard/productGoalData", params, successCallback, failCallback, exceptionCallback);
    },
    trendslist: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/product/productBoard/trendslist", params, successCallback, failCallback, exceptionCallback);
    },
    //添加动态
    saveTrends: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/product/productBoard/saveTrends", params, successCallback, failCallback, exceptionCallback);
    },
}
export default api;
